import React from 'react';
import BarChart from '../../charting/BarChart/BarChart.jsx';
const chartstyles= {
  width   : "100%",
  height  : 320,
  paddingLeft : 90,
  paddingRight: 10,
  paddingTop: 20,
  paddingBottom: 10,
  barSpacing: 3,
  groupSpacing: 5,
  hideYAxis:true,
  horizontal:true,
  labelsWithBars:true,
  valuesOnBars:true,
  barLabelColor: "#f5f5f5",
  reverseYAxis: true,
  legendDisplay: "none",
};

export default (props) => {
    return <BarChart {...chartstyles} {...props}/>
}


// WEBPACK FOOTER //
// ./src/js/components/special/AQIChart/AQIChart.jsx